export default __webpack_public_path__ + "static/media/itb.de5b6d16.png";